import { createFileRoute } from "@tanstack/react-router";
import { useOrganization } from "@/lib/auth";
import { RouteShell } from "@/design-system";
import { PageChrome } from "@/components/chrome/PageChrome";
import { useEntitlements } from "@/hooks/useBilling";
import { UsageHeadline } from "@/components/settings/usage/UsageHeadline";
import { UsageMeters } from "@/components/settings/usage/UsageMeters";

export const Route = createFileRoute("/settings/usage")({
  component: UsagePage,
});

function UsagePage() {
  const { organization } = useOrganization();
  const orgName = organization?.name ?? "";
  const entitlements = useEntitlements();

  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      <PageChrome
        crumbs={[
          { label: orgName || "Org", to: "/dashboard" },
          { label: "Settings" },
          { label: "Usage" },
        ]}
        title="Usage"
        helper="Targets, seats, and scans consumed in the current billing cycle."
      />
      <div className="flex-1 overflow-auto px-4 sm:px-7 py-6">
        <div className="flex flex-col gap-5">
          <RouteShell
            isPending={entitlements.isPending}
            error={entitlements.error}
          >
            {entitlements.data ? (
              <>
                <UsageHeadline entitlements={entitlements.data} />
                <UsageMeters entitlements={entitlements.data} />
              </>
            ) : null}
          </RouteShell>
        </div>
      </div>
    </div>
  );
}
